/* tslint:disable */
/* eslint-disable */
/* @relayHash 9ccc8f6c231d6997bd696edb9ba7db56 */

import { ConcreteRequest } from "relay-runtime";
export type DeleteExerciseInput = {
    id: string;
    clientMutationId?: string | null;
};
export type DeleteExerciseMutationVariables = {
    input: DeleteExerciseInput;
};
export type DeleteExerciseMutationResponse = {
    readonly deleteExercise: {
        readonly id: string;
    } | null;
};
export type DeleteExerciseMutation = {
    readonly response: DeleteExerciseMutationResponse;
    readonly variables: DeleteExerciseMutationVariables;
};



/*
mutation DeleteExerciseMutation(
  $input: DeleteExerciseInput!
) {
  deleteExercise(input: $input) {
    id
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "DeleteExerciseInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "deleteExercise",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteExercisePayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "DeleteExerciseMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "DeleteExerciseMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "DeleteExerciseMutation",
    "id": null,
    "text": "mutation DeleteExerciseMutation(\n  $input: DeleteExerciseInput!\n) {\n  deleteExercise(input: $input) {\n    id\n  }\n}\n",
    "metadata": {}
  }
};
})();
(node as any).hash = 'b0fd789316b453ea625d48df9f158176';
export default node;
